import classNames from "classnames";
import Text from "pages/_components/Text";
import Box from "pages/_components/Box";
import { bool, func, string } from "prop-types";
import { Modal } from "react-bootstrap";
import React from "react";
import { connect } from "react-redux";
import * as i18nUtils from "util/i18n";

const SideBarModal = ({
    children,
    onClose,
    show,
    title,
    modalId,
    scrollable,
    modalContainerClassName,
    modalBodyClassName,
    modalHeaderClassName,
}) => (
    <Modal
        aria-labelledby={`modal-${modalId}-${i18nUtils.get(title)}`}
        aria-modal="true"
        onHide={() => {
            onClose();
        }}
        show={show}
        className={classNames("drawer")}>
        <div className={classNames("modal-container", modalContainerClassName)}>
            <Modal.Header closeButton className={modalHeaderClassName}>
                <Text id="modalTitleID" component="h4" labelKey={title} className="modal-title" />
            </Modal.Header>
            <Modal.Body className={modalBodyClassName}>
                <Box
                    display="flex"
                    fullWidth
                    className={classNames("px-0 px-md-9", { "modal-scrollable-content": scrollable })}
                    flex1>
                    {children}
                </Box>
            </Modal.Body>
        </div>
    </Modal>
);

SideBarModal.propTypes = {
    children: func,
    onClose: func,
    show: bool,
    title: string,
    modalId: string,
    scrollable: bool,
    modalContainerClassName: string,
    modalBodyClassName: string,
    modalHeaderClassName: string,
};

SideBarModal.defaultProps = {
    children: "",
    onClose: () => {},
    show: false,
    title: "",
    modalId: "",
    scrollable: false,
    modalContainerClassName: null,
    modalBodyClassName: null,
    modalHeaderClassName: null,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(SideBarModal);
